export class Guess {
  make: string;
  model: string;
  makeCorrect: boolean;
  modelCorrect: boolean;

  constructor(make: string, model: string, makeCorrect: boolean, modelCorrect: boolean) {
    this.make = make;
    this.model = model;
    this.makeCorrect = makeCorrect;
    this.modelCorrect = modelCorrect;
  }
}